const compactCurrencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumSignificantDigits: 3,
});

/** `0 → $0`, `865432 → $865K`, `1420000 → $1.42M`, `-865432 → -$865K`; empty string for a missing or non-finite value. */
export function formatCompactCurrency(amount: number | null | undefined): string {
  if (typeof amount !== 'number' || !Number.isFinite(amount)) {
    return '';
  }
  return compactCurrencyFormatter.format(amount);
}
